import { render } from "./Activitati.vue?vue&type=template&id=544dfafd"
import script from "./Activitati.vue?vue&type=script&lang=js"
export * from "./Activitati.vue?vue&type=script&lang=js"

import "./Activitati.vue?vue&type=style&index=0&id=544dfafd&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__